import * as z$1 from "zod/v4";
//#region src/schemas/http/organization-information-protection.ts
const ORGANIZATION_PROTECTED_INFORMATION_MAX_CHARS = 2e3;
const boundedIdentifierSchema = z$1.string().trim().min(1).max(256);
const isoDateTimeSchema = z$1.iso.datetime({ offset: true });
const organizationProtectedInformationSchema = z$1.string().trim().min(1).max(ORGANIZATION_PROTECTED_INFORMATION_MAX_CHARS);
const organizationInformationProtectionPolicyResponseSchema = z$1.strictObject({
	organizationId: boundedIdentifierSchema,
	protectedInformation: organizationProtectedInformationSchema.nullable(),
	updatedAt: isoDateTimeSchema.nullable(),
	updatedByUserId: boundedIdentifierSchema.nullable()
});
const updateOrganizationInformationProtectionPolicyBodySchema = z$1.strictObject({ protectedInformation: organizationProtectedInformationSchema.nullable() });
//#endregion
export { ORGANIZATION_PROTECTED_INFORMATION_MAX_CHARS, organizationInformationProtectionPolicyResponseSchema, organizationProtectedInformationSchema, updateOrganizationInformationProtectionPolicyBodySchema };

//# sourceMappingURL=organization-information-protection.js.map